import { FiEye } from "react-icons/fi";
import { PanelCard } from "./dashboardShared";
import { usePreviewAccessCode } from "../../hooks/usePreviewAccessCode";

/**
 * Dashboard card showing the current weekly PREVIEW access code and when it rotates. Editors read the
 * code here to unlock the preview site manually; links from the admin already carry it automatically.
 * Hidden when no secret is configured (local dev) so the card never shows a blank code.
 */
export const PreviewAccessCard: React.FC = () => {
	const { data, loading } = usePreviewAccessCode();

	if (loading || !data?.configured) return null;

	const days = data.daysUntilRotation;
	const daysLabel = days <= 0 ? "aujourd'hui" : `${days} jour${days > 1 ? "s" : ""}`;

	return (
		<PanelCard
			title="Accès preview"
			subtitle="Code hebdomadaire : à saisir pour ouvrir le site de preview"
			action={<FiEye className="h-4 w-4 text-slate-400" aria-hidden />}
		>
			<div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4">
				<div className="min-w-0">
					<p className="text-[0.7rem] font-semibold uppercase tracking-wide text-slate-400">
						Code d'accès preview
					</p>
					<p className="font-mono text-3xl font-bold tracking-[0.35em] text-slate-900">{data.code}</p>
				</div>
				<div className="text-right">
					<p className="text-xs text-slate-400">Nouveau code dans</p>
					<p className="text-lg font-semibold text-[#005CA9]">{daysLabel}</p>
				</div>
			</div>
		</PanelCard>
	);
};
